<!-- 지표보고서, 기타자료실 게시판 리스트 -->
<template>
  <div class="notice-list stat">
    <div class="ebook-list">
      <a href="javascript:;" class="ebook-item" v-for="(data, idx) in boardListData" v-bind:key="idx"
        @click.prevent="showDetailView(data.boardId, data.boardType, data.orderRowNum)">
        <div class="thumbnail">
          <img :src="findimage(data)" alt="">
          <span v-html="data.stblTypeNm" class="category"></span>
        </div>
        <div class="thumbnail-info">
          <div class="ebook-top">
            <h3 class="ebook-title">{{ data.boardtitle }}</h3>
            <p class="ebook-cnt">{{ data.boardDescription }}</p>
          </div>
          <div class="ebook-bottom bundle">
            <div class="bundle">
              <p class="date">{{ data.dateYy }}.{{ data.dateMm }}.{{ data.dateDd }}</p>
              <p class="viewer">{{ data.srchCnt }}</p>
            </div>
            <div class="bundle">
              <button type="button" @click.stop="fileViewer({ boardId: data.boardId, attachFileList: data.attachFileList })" class="ico_search" title="바로보기">바로보기</button>
              <button type="button" @click.stop="fileDownload({ boardId: data.boardId, attachFileList: data.attachFileList })" class="ico_down" title="다운로드">다운로드</button>
            </div>
          </div>
        </div>
      </a>
    </div>
    <div class="notice-content" v-show="isNoBoardData">
      <strong>게시글이 존재하지 않습니다.</strong>
    </div>
  </div>
</template>

<script>
import * as file from '@/api/common/file.js'
import * as staticApi from '@/api/Statistics.js'
import * as api from '@/api/Notice.js'

export default {
	name: 'IndexReportListItem',

	data () {
		return {
			isNoBoardData: false
		}
	},

	props: {
		boardListData: {
			type: Array,
			required: true
		},
		searchText: {
			type: String,
			required: true
		},
		boardName: {
			type: String,
			required: true
		}
	},

	watch: {
		boardListData: function () {
			if (this.boardListData.length > 0) {
				this.isNoBoardData = false
			} else {
				this.isNoBoardData = true
			}
		}
	},

	methods: {
		// 게시판 상세보기
		showDetailView (boardId, boardType, orderRowNum) {
			this.$emit('showDetailView', boardId, boardType, orderRowNum)
		},

		// 첨부파일 다운로드
		async fileDownload (data) {
			let fileMgmNo = ''
			let rptFileGb = ''
			for (const fileData of data.attachFileList) {
				rptFileGb = fileData.rptFileGb
				if (rptFileGb == '01') {
					fileMgmNo = fileData.rptFileSeq
					break
				}
			}

			// 파일 다운로드 파라미터 설정
			const params = {
				type: 'board',
				boardId: data.boardId,
				fileMgmNo: fileMgmNo
			}
			console.log(params.boardId)

			// 파일 다운로드 호출
			await file.download(params)

			// 파일 다운로드 로그
			const logParams = {
				downMenu: this.boardName,
				downCntn: fileMgmNo
			}
			await staticApi.insertExcelDownLog(logParams)
		},

		// 썸네일
		findimage (data) {
			try {
				let fileGb = ''
				let directoryPath = ''
				for (const fileData of data.attachFileList) {
					fileGb = fileData.fileGb.toLowerCase()
					if (fileGb === '02') {
						directoryPath = fileData.directoryPath;
            if (directoryPath.indexOf('SsemNoticeBoard') > -1) {
              directoryPath = 'https://stat.mcst.go.kr/mng/' + directoryPath;
            }

            directoryPath = directoryPath.replace('http:', 'https:')
            return directoryPath;
					}
				}
			} catch (e) {
				return require('@/assets/img/default_thumbnail.png')
			}
			return require('@/assets/img/default_thumbnail.png')
		},

		// 파일 바로보기
		async fileViewer (data) {
			try {
				const frm = new FormData()
				let fileMgmNo = ''
				for (const fileData of data.attachFileList) {
					if (fileData.fileGb == '01') {
						fileMgmNo = fileData.fileMgmNo
						break
					}
				}

				if (fileMgmNo) {
					frm.append('type', 'BOARD')
					frm.append('boardId', data.boardId)
					frm.append('fileMgmNo', fileMgmNo)

					const statisticsData = await api.fileConvert(frm)
					const openUrl = statisticsData.data
					if (openUrl) {
						window.open(openUrl, '_blank')
					} else {
						console.error('URL 이상')
					}
				} else {
					console.error('파일관리번호 없음')
				}
			} catch (error) {
				console.error('파일 뷰어 열기 중 오류 발생 : ', error)
			}
		}
	}
}
</script>

<style scoped>
.notice-list-inner li:hover {
  cursor: pointer;
}

.notice-content {
  width: 100%;display: flex;
  justify-content: center;
  align-items: center;
  height: 200px;
}

.fileBtn {
  text-transform: uppercase;
}
</style>
